import {use} from 'react'

import {RootElementContext} from '../context/RootElementContext'

export function useRootElement() {
  const rootElement = use(RootElementContext)
  return rootElement
}
